import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { AuthProvider, ErrorProvider } from './providers';
import './App.css';

import DefaultLayout from './layouts/DefaultLayout';
import OriginalRouter from './pages/PageRouter';
import Donation from './pages/Donation';
import DonationThankYou from './pages/DonationThankYou';


function LegacyApp() {
    return (
        <ErrorProvider>
            <AuthProvider>
                <BrowserRouter basename={'/'}>
                    <Switch>
                        <Route path='/tip/:streamer?' component={Donation} />
                        <Route path='/donate/:streamer?' component={Donation} />
                        <Route path='/thank-you' component={DonationThankYou} />
                        <Route path="*" render={() =>
                            <DefaultLayout>
                                <OriginalRouter />
                            </DefaultLayout>
                        } />
                    </Switch>
                </BrowserRouter>
            </AuthProvider>
        </ErrorProvider>
    )
}

export default LegacyApp
